import React from "react";

import Text from "src/components/text";
import { formatTimespent } from "src/services/reports.service";

import { CampaignItem } from "src/types/reports";

import styles from "./campaignListItem.module.scss";

interface CampaignListItemProps {
  item: CampaignItem;
  columnCount: number;
}

const CampaignListItem: React.FC<CampaignListItemProps> = ({
  item,
  columnCount,
}) => {
  const { name, analytics, manualIndex } = item;
  return (
    <div key={item.id} className={styles.tableRow}>
      <div className={styles.tableDataContainer}>
        <div className={styles.queryItem}>
          <div className={styles.queryNumber}>{manualIndex}</div>
          <div className={styles.data}>
            <Text text={name || ""} className={styles.campaigns} lines={1} />
          </div>
        </div>
      </div>

      <div
        className={styles.analyticsContainer}
        style={{
          gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))`,
        }}
      >
        <span className={styles.tableDataViews}>{analytics?.views || 0}</span>
        <span className={styles.tableDataViews}>
          {formatTimespent(analytics?.avgTimeSpent || 0)}
        </span>
        <span className={styles.tableDataViews}>{analytics?.assets || 0}</span>
      </div>
    </div>
  );
};

export default CampaignListItem;
